import { useCallback } from "react";

import {
  CurrencySymbols,
  OnPriceShownCallback,
  PriceConfig,
  priceConfigQueryKey,
  PriceConfigResponseData,
  SubscriptionPeriod,
  TierPriceConfig,
  usePriceConfig as useSharedPriceConfig,
} from "@repo/ui/pricing-hooks";

import { UMSApiUrl } from "../config";
import { SubscriptionTier } from "../types";
import { useTracker } from "./useTracker";

export type { OnPriceShownCallback, PriceConfig, PriceConfigResponseData, TierPriceConfig };
export { CurrencySymbols, priceConfigQueryKey, SubscriptionPeriod };

export function usePriceConfig() {
  const tracker = useTracker();
  const onPriceShown = useCallback(
    (params: Parameters<OnPriceShownCallback>[0]) => tracker.trackPriceShown(params),
    [tracker]
  );
  return useSharedPriceConfig({ apiBaseUrl: UMSApiUrl, onPriceShown });
}

export const useHasStudioPricing = () => {
  const { data: priceConfig, isPending } = usePriceConfig();
  return { isPending, isStudioTier: Boolean(priceConfig?.tiers[SubscriptionTier.Studio]) };
};
